module.exports = __webpack_public_path__ + "img/loadingImg.7341e0ad.svg";